export default {
  setUserInfo(state, userInfo) {
    state.userInfo = userInfo
  },
  setMenus(state, menus) {
    state.menus = menus
  },
  setAuthTreeData(state, initAuthTreeData) {
    state.initAuthTreeData = initAuthTreeData
  },
  setAuthButtonList(state, authButtonList) {
    state.authButtonList = authButtonList
  },
  setUrlCookie(state, urlCookie) {
    state.urlCookie = urlCookie
  },
  // 更新面包屑导航列表
  setBreadNav(state, value) {
    state.breadNav = value || []
  },
  setRole(state, role) {
    state.role = role;
  },
  setArea(state, areaList) {
    state.areaList = areaList;
  }
}